import { CommonProps } from '@va/types/component';
import { fontWeights, Paragraph, paragraphSizes, ParagraphWithTooltip } from '@va/ui/design-system';
import classNames from 'classnames';
import { PropsWithChildren } from 'react';

export const DomainItemContainer = ({ children }: PropsWithChildren<CommonProps>) => {
  return (
    <div className='bg-white-snow rounded-r-15 rounded-l-30 p-1 flex items-center gap-3 overflow-hidden'>
      {children}
    </div>
  );
};

export const DomainItemStatusBadge = ({
  label,
  icon,
  className,
}: {
  label: string;
  icon: React.ReactNode;
  className: string;
}) => {
  return (
    <div className={classNames('py-2 px-3 rounded-30 flex gap-2 items-center', className)}>
      {icon}
      <Paragraph weight={fontWeights.semibold}>{label}</Paragraph>
    </div>
  );
};

export const DomainItemValue = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className='overflow-hidden'>
      <Paragraph weight={fontWeights.medium} colorClassName='text-gray-devil' size={paragraphSizes.tiny}>
        {label}
      </Paragraph>
      <ParagraphWithTooltip weight={fontWeights.semibold}>{value}</ParagraphWithTooltip>
    </div>
  );
};
